import createModule from "../createModule"
import view from "./view"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import { getSortedContributors, getSortedGroupContributors, getSelectedGroupValue, getAvailableRollups, getContributorsSummaryText, getCsvData, getSelectedGroupSiblings, getSelectedGroup } from "./selectors"
import { getGroupsDropdownColumns } from "./selectors/group"
import { getSegment } from "modules/analyze-header/selectors/segment"
import { generateClassificationQueryForContributors, getClassifications } from "helpers/classification"
import { getForecastId } from "../analyze-forecast/selectors/items"
import { getIsOpPro } from "modules/account-root/selectors"
import { getQueryGroupBy } from "helpers/rollups"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state, props),
    segment: getSegment(state, props),
    classifications: getClassifications(state, props),
    forecastId: getForecastId(state, props),
  }),
  required: ["portfolioId", "account"],
  data: [{
    resource: "forecastContributors",
    as: null,
    url: ({ portfolioId, modelId, forecastId, selectedDate, viewType, segment, classifications }) => {
      if (!selectedDate || !forecastId) { return null }
      return {
        id: `forecastContributors-${modelId}${portfolioId}${forecastId}${selectedDate}${viewType}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $portfolioId: String!, $forecastId: ShortId!, $date: Date!, $segment: Segment) {
            model (id: $modelId) {
              simulation (positionSet: {
                type: PORTFOLIO,
                id: $portfolioId,
                segment: $segment
              }, from: $date, to: $date, interval: END_DATE) {
                forecastContributors (on: $date, forecastId: $forecastId) {
                  date
                  contributors{
                    assetClass
                    assetSubclass
                    id
                    country
                    currency
                    ${generateClassificationQueryForContributors("GICS", classifications)}
                    description
                    bloombergTicker
                    percentEquity
                    weightedExpectedReturn
                    modelProviderId
                  }
                }
              }
            }
          }`,
        variables: {
          modelId,
          portfolioId,
          forecastId,
          date: selectedDate,
          segment,
        },
      }
    },
  }, {
    resource: "groupedForecastContributors",
    as: null,
    url: ({ portfolioId, modelId, forecastId, selectedDate, viewType, contributorsGrouping, segment, classifications }) => {
      if (!contributorsGrouping) {
        return null
      }

      const queryGroupBy = getQueryGroupBy(contributorsGrouping)

      return {
        id: `groupedForecastContributors-${modelId}${portfolioId}${selectedDate}${viewType}${JSON.stringify(queryGroupBy)}${JSON.stringify(segment)}`,
        query: `query ($modelId: String!, $portfolioId: String!, $forecastId: ShortId!, $date: Date!, $groupBy: ContributorGroupType!, $groupById: String, $tier: String, $segment: Segment) {
            model (id: $modelId) {
              simulation (positionSet: {
                type: PORTFOLIO,
                id: $portfolioId,
                segment: $segment
              }, from: $date, to: $date, interval: END_DATE) {
                groupedForecastContributors (on: $date, forecastId: $forecastId, groupBy: $groupBy, groupById: $groupById, classificationTier: $tier) {
                  date
                  groupedContributors {
                    name
                    id
                    totalPercentEquity
                    totalExpectedReturn
                    contributors {
                      id
                      assetClass
                      country
                      ${generateClassificationQueryForContributors("GICS", classifications)}
                      currency
                      description
                      percentEquity
                      weightedExpectedReturn
                      bloombergTicker
                      modelProviderId
                    }
                  }
                }
              }
            }
          }`,
        variables: {
          modelId,
          portfolioId,
          forecastId,
          date: selectedDate,
          segment,
          ...queryGroupBy,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    data: getSortedContributors(state, props),
    groupedData: getSortedGroupContributors(state, props),
    availableRollups: getAvailableRollups(state, props),
    contributorsSummaryText: getContributorsSummaryText(state, props),
    csvData: getCsvData(state, props),
    selectedGroup: getSelectedGroup(state, props),
    selectedGroupValue: getSelectedGroupValue(state, props),
    isOpPro: getIsOpPro(state, props),
    selectedGroupSiblings: getSelectedGroupSiblings(state, props),
    groupsDropdownColumns: getGroupsDropdownColumns(state, props),
    ...state.modules.forecastContributors,
  }),
  actions: {
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
